import ym from 'react-yandex-metrika';

class YMService {

	onLogin(userId: number | null) {
		ym('userParams', { UserID: userId })
	}

	onFormSubmit() {
		ym('reachGoal', 'b2b_laba_rkp_submit_form')
	}
};

const YM = new YMService();

export default YM;
